export const CURSORS = [
  `Select`,
  `Pen`,
  `Pan`,
  `Pan_Grab`,
  `Erase`,
  `Edge_Black`,
  `Edge_Eave`,
  `Edge_Hip`,
  `Edge_Rake`,
  `Edge_Ridge`,
  `Edge_Valley`,
  `Move_All`,
  `Panel_Place`,
  `Panel_Erase`,
  `Panel_Minus`,
  `Panel_Plus`,
  `Widen`,
] as const
export type Cursor = (typeof CURSORS)[number]

export const getCursorFile = (cursor: Cursor): string => {
  switch (cursor) {
    case `Select`:
      return `url("/cursors/Select.svg") 4 4, pointer`
    case `Pen`:
      return `url("/cursors/Pen.svg") 4 4, pointer`
    case `Pan`:
      return `url("/cursors/Pan.svg") 12 12, move`
    case `Pan_Grab`:
      return `url("/cursors/Pan_Grab.svg") 12 12, move`
    case `Erase`:
      return `url("/cursors/Erase.svg") 4 20, pointer`
    case `Edge_Black`:
      return `url("/cursors/Edge_Black.svg") 0 20, pointer`
    case `Edge_Eave`:
      return `url("/cursors/Edge_Eave.svg") 0 20, pointer`
    case `Edge_Hip`:
      return `url("/cursors/Edge_Hip.svg") 0 20, pointer`
    case `Edge_Rake`:
      return `url("/cursors/Edge_Rake.svg") 0 20, pointer`
    case `Edge_Ridge`:
      return `url("/cursors/Edge_Ridge.svg") 0 20, pointer`
    case `Edge_Valley`:
      return `url("/cursors/Edge_Valley.svg") 0 20, pointer`
    case `Move_All`:
      return `url("/cursors/Move_All.svg") 12 12 , all-scroll`
    case `Panel_Place`:
      return `url("/cursors/Panel_Place.svg") 12 12, crosshair`
    case `Panel_Erase`:
      return `url("/cursors/Panel_Erase.svg") 12 12, crosshair`
    case `Panel_Minus`:
      return `url("/cursors/Panel_Activator_Minus.svg") 4 4, crosshair`
    case `Panel_Plus`:
      return `url("/cursors/Panel_Activator_Plus.svg") 4 4, crosshair`
    case `Widen`:
      return `url("/cursors/Widen.svg"), col-resize`
    default:
      return `auto`
  }
}
